<template>
  <div class="bg-white m-0">
    <CContainer>
      <CRow>
        <CCol sm="4">
          <div class="text-left custom-24px ml-4 mt-5">GenieWorkers</div>
          <label
            class="custom-18px text-black-dark ml-4 mt-4"
            style="font-weight:400"
            >Our AI Genie Deliver You Wishes</label
          >
          <br />
         
        </CCol>
        <CCol sm="2">
          <label class="label-custom-header-subtitle poppin-font mt-5">Navigate</label>
          <br />
          <label
            class="custom-16px text-black pointer mt-3"
            @click="GoToAbout"
            ><strong>About Us</strong></label
          >
          <br />
          <label
            class="custom-16px text-black pointer"
            @click="GoToContact"
            ><strong>Contact Us</strong></label
          >
        
        </CCol>
        <CCol sm="2">
          <label class="label-custom-header-subtitle poppin-font mt-5">Link</label>
          <br />
          <label
            class="custom-16px text-black pointer mt-3"
            ><strong>Privacy Policy</strong></label
          >
          <br />
          <label
            class="custom-16px text-black pointer"
            ><strong>Terms & Condition</strong></label
          >
          <br />
          <label
            class="custom-16px text-black pointer"
            ><strong>FAQs</strong></label
          >
        
        </CCol>
        <CCol sm="4">
          <div class="text-left text-black ml-1 mt-5">Newsletter</div>
          <CRow class="mt-3">
            <CCol sm="10"> <CInput type="text" /></CCol>
            <CCol sm="2">  <CButton class="button-Explore-dark"><span class="ml-2 mr-2">Submit</span></CButton></CCol>
          </CRow>
        
        
          <label class="custom-16px text-black mt-2"
            ><strong>Download Now</strong></label
          >
          <br />
          <CRow class="mt-3">
            <CCol sm="6"> <img style="max-width:100%" src="../assets/img/googleplay.png" /></CCol>
            <CCol sm="6"> <img style="max-width:100%" src="../assets/img/appstore.png" /></CCol>
          </CRow>
        </CCol>
          <CCol sm="6"><label class="label-custom-header-subtitle poppin-font mt-5">© 2024 GenieWorker</label></CCol>
          <CCol sm="6"><div class="text-right mt-5">
            <img src="../assets/img/SocialMedia.png" />
          </div></CCol>
      
      </CRow>
    </CContainer>
  </div>
</template>

<script>
export default {
  name: "TheFooter",
  data() {
    return {
    
    };
  },
  methods: {
    GoToAbout() {
      this.$router.push("About");
    },
    GoToContact() {
      this.$router.push("ContactUs");
    },
    GoToLegal() {
      this.$router.push("Legal");
    },
    GoToBlog() {
      this.$router.push("Blog");
    },
    GoToLinkedIn() {
      window.open("https://www.linkedin.com/company/70999536/");
    },
    GoToFacebook() {
      window.open("https://www.facebook.com/pickiddo");
    },
    GoToInstagram() {
      window.open("https://www.instagram.com/pickiddo");
    },
    GoToTiktok() {
      window.open("https://www.tiktok.com/@pickiddo");
    },
    GoToYoutube() {
      window.open("https://www.youtube.com/@pickiddo");
    },
    GoToWhatsapp()
    {
      window.open("https://wa.me/600106597700");
    },

    changeImageSrc() {
      // Change image source to hover image source
      this.imageSrc = this.hoverImageSrc;
    },
    resetImageSrc() {
      // Reset image source to original image source
    },
    changeImageSrcInsta() {
      // Change image source to hover image source
      this.imageSrcInsta = this.hoverImageSrcInsta;
    },
    resetImageSrcInsta() {
      // Reset image source to original image source
    },
    changeImageSrcFb() {
      // Change image source to hover image source
      this.imageSrcFb = this.hoverImageSrcFb;
    },
    resetImageSrcFb() {
      // Reset image source to original image source
    },
    changeImageSrcLn() {
      // Change image source to hover image source
      this.imageSrcLn = this.hoverImageSrcLn;
    },
    resetImageSrcLn() {
      // Reset image source to original image source
    },
    changeImageSrcWs() {
      // Change image source to hover image source
      this.imageSrcWs = this.hoverImageSrcWs;
    },
    resetImageSrcWs() {
      // Reset image source to original image source
    },
    changeImageSrcYou() {
      // Change image source to hover image source
      this.imageSrcYou = this.hoverImageSrcYou;
    },
    resetImageSrcYou() {
      // Reset image source to original image source
    },
  },
};
</script>
<style>

.pointer:hover {
  cursor: pointer;
  text-decoration: underline;
}
.hover-pointer1 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
.hover-pointer2 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
.hover-pointer3 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
.hover-pointer4 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
.hover-pointer5 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
.hover-pointer6 {
  cursor: pointer; /* Set cursor to pointer on hover */
}
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");
</style>
  

